import { Link } from "react-router-dom";
import { categories } from "@/mocks/events";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vidicon-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                吃瓜视频<span className="text-primary-500">在线</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-500">
              聚合全网热点事件现场实拍，事件合集按主题分类，路人视角真实记录。从冲突现场到对话录音，全程无剪辑呈现，第一时间掌握事件全貌。
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-foreground-800">主题分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="inline-flex items-center gap-2 text-sm text-foreground-500 transition hover:text-primary-500"
                  >
                    <i className={`${c.icon} text-xs`}></i>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-foreground-800">快捷导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-500">
              <li><Link to="/" className="transition hover:text-primary-500">首页</Link></li>
              <li><Link to="/category" className="transition hover:text-primary-500">全部事件</Link></li>
              <li><Link to="/about" className="transition hover:text-primary-500">关于我们</Link></li>
              <li><Link to="/about#values" className="transition hover:text-primary-500">内容原则</Link></li>
              <li><Link to="/about#faq" className="transition hover:text-primary-500">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-foreground-800">互动与联系</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-500">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-xs"></i> contact@chigua-video.example</li>
              <li className="flex items-center gap-2"><i className="ri-time-line text-xs"></i> 每日 09:00 – 22:00 更新</li>
            </ul>
            <div className="mt-4 flex gap-2.5">
              {["ri-wechat-line", "ri-weibo-line", "ri-send-plane-line", "ri-youtube-line"].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  aria-label="社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition hover:border-primary-500 hover:text-primary-500"
                >
                  <i className={`${ic} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>© 2026 吃瓜视频在线 · 理性吃瓜，就事论事</p>
          <p className="flex flex-wrap gap-x-4 gap-y-1">
            <span>现场实拍</span>
            <span>事件合集</span>
            <span>路人视角</span>
            <span>全程记录</span>
          </p>
        </div>
      </div>
    </footer>
  );
}